<template>
  <v-dialog
    v-model="dialog"
    :change="toggleDialog()"
    class="base-dialog-to-select-nfe"
    max-width="1000"
    transition="dialog-top-transition"
  >
    <div class="card-dialog">
      <div class="title-text d-flex justify-space-between align-center">
        {{ $t('components.dialogs.base_dialog_to_select_nfe.title') }}

        <div class="filter-by-year">
          <select
            class="year-select"
            @change="filterByYear"
          >
            <option value="">
              {{ $t('components.dialogs.base_dialog_to_select_nfe.filter_by_year') }}
            </option>
            <option
              v-for="year in getYears()"
              :key="year"
              :value="year"
            >
              {{ year }}
            </option>
          </select>

          <v-checkbox
            v-model="selectAll"
            color="text_color"
            @click="handleSelect"
          >
            <template v-slot:label>
              <span class="text_color--text">Selecionar Todas</span>
            </template>
          </v-checkbox>
        </div>
      </div>

      <div class="nfes-content">
        <card-info-quantity
          :material-type="materialType"
          :has-nfes="true"
          :border-radius="false"
          :total-quantity="totalQuantity"
        />
        <div
          :class="[materialType, 'nfe-list']"
        >
          <div class="title-list">
            {{ $t('components.credit_to_offer.title_nfes_available') }}
          </div>
          <div
            :class="[materialType, 'nfes-files']"
          >
            <base-file-nfe
              v-for="(nfe, index) in nfes"
              v-if="shouldShowNfe(nfe)"
              :key="index"
              :nfe="nfe"
              :index="index"
              :nfe-selected="nfe.selectedToOffer"
              :material-type="materialType"
              :enable-selection="true"
              :is-dialog="true"
              @selectNfeToOffer="selectNfeToOffer"
            />
          </div>
        </div>
      </div>
    </div>

    <button
      class="button-dialog"
      @click="closeDialog"
    >
      {{ $t('components.credit_to_offer.button') }}
    </button>
  </v-dialog>
</template>
<script>
import CardInfoQuantity from '@/components/cards/credit_offered/credit_to_offer_components/CardInfoQuantity.vue';
import BaseFileNfe from '@/components/cards/credit_offered/credit_to_offer_components/BaseFileNfe.vue';

export default {
  name: 'BaseDialogToSelectNfe',
  components: { CardInfoQuantity, BaseFileNfe },

  model: {
    prop: 'openDialog',
    event: 'change',
  },

  props: {
    openDialog: {
      type: Boolean,
      default: false,
    },

    nfes: {
      type: Array,
      default: () => [],
    },

    materialType: {
      type: String,
      default: '',
    },

    totalQuantity: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      dialog: false,
      selectedYear: '',
      selectAll: true,
    };
  },

  computed: {
    selectedNfes() {
      return this.nfes.filter(this.shouldShowNfe).every((nfe) => nfe.selectedToOffer || nfe.select);
    },
  },

  watch: {
    openDialog(value) {
      this.dialog = value;
    },

    selectedNfes(value) {
      this.selectAll = value;
    },
  },

  methods: {
    toggleDialog() {
      this.$emit('change', this.dialog);
    },

    closeDialog() {
      this.dialog = false;
    },

    selectNfeToOffer(nfe) {
      this.$emit('selectNfeToOffer', nfe);
    },

    filterByYear(year) {
      this.selectedYear = year.target.value;
    },

    handleSelect() {
      if (this.selectAll) this.selectAllNfes();
      else this.removeAllNfes();
    },

    selectAllNfes() {
      const nfeList = this.nfes.map((nfe) => ({
        ...nfe,
        select: this.shouldShowNfe(nfe) || nfe.selectedToOffer,
      }));

      this.$emit('ensureSelectedNfes', nfeList);
    },

    removeAllNfes() {
      const nfeList = this.nfes.map((nfe) => ({
        ...nfe,
        select: this.shouldShowNfe(nfe) ? false : nfe.selectedToOffer,
      }));

      this.$emit('ensureSelectedNfes', nfeList);
    },

    getYears() {
      const years = new Set();

      this.nfes.forEach((nfe) => {
        years.add(nfe.issue_date.split('/')[2]);
      });

      return Array.from(years);
    },

    shouldShowNfe(nfe) {
      return nfe.issue_date.split('/')[2] === this.selectedYear || this.selectedYear === '';
    },
  },
};
</script>
<style lang="scss" scoped>
.card-dialog {
  .title-text {
    background-color: $color_primary;
    padding: 20px;
    font-weight: bold;
    color: $color_white;
  }

  .nfes-content {
    display: flex;
    height: calc(67vh - 33px);

    .nfe-list {
      width: 65%;
      padding: 30px;
      border-bottom-right-radius: 8px;

      &.paper {
        background-color: $background_list_nfes_file_paper;
      }

      &.plastic {
        background-color: $background_list_nfes_file_plastic;
      }

      &.glass {
        background-color: $background_list_nfes_file_glass;
      }

      &.metal {
        background-color: $background_list_nfes_file_metal;
      }

      .title-list {
        color: $color_gray;
        font-weight: bold;
        text-align: center;
        margin-bottom: 30px;
      }

      .nfes-files {
        margin-top: 20px;
        overflow-y: auto;
        height: calc(100vh - 450px);

        &::-webkit-scrollbar {
          width: 12px;
        }

        &::-webkit-scrollbar-track {
          background: $files_backgrond;
        }

        &::-webkit-scrollbar-thumb {
          border-radius: 20px;
          border: 0.1875em solid $files_backgrond;
        }

        &.paper {
          &::-webkit-scrollbar-thumb {
            background-color: $border_color_card_paper;
          }
        }

        &.plastic {
          &::-webkit-scrollbar-thumb {
            background-color: $border_color_card_plastic;
          }
        }

        &.glass {
          &::-webkit-scrollbar-thumb {
            background-color: $border_color_card_glass;
          }
        }

        &.metal {
          &::-webkit-scrollbar-thumb {
            background-color: $border_color_card_metal;
          }
        }
      }
    }
  }
}

.button-dialog {
  margin-top: 40px;
  border-radius: 10px;
  color: $color_light;
  font-size: 1.5em;
  font-weight: bold;
  background: $color_primary;
  height: 70px;
}

.filter-by-year {
  display: flex;
  align-items: center;
  gap: 10px;

  .year-select {
    width: 100%;
    padding: 12px 16px;
    border: 1px solid $color_gray;
    border-radius: 4px;
    background-color: $color_light;
    color: $color_dark;
    font-size: 14px;
    cursor: pointer;
    appearance: none;
    background-repeat: no-repeat;
    background-position: right 12px center;
    background-size: 16px;
    transition: all 0.3s ease;

    &:focus {
      outline: none;
      border-color: $color_primary;
      box-shadow: 0 0 0 2px rgba($color_primary, 0.2);
    }

    &:hover {
      border-color: $color_primary;
    }

    option {
      padding: 8px;
      background-color: $color_light;
      color: $color_dark;
    }
  }
}
</style>
